import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venue-accomodation26',
  templateUrl: './venue-accomodation26.component.html',
  styleUrls: ['./venue-accomodation26.component.css']
})
export class VenueAccomodationComponent26 implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
